import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { func } from 'prop-types';

import styles from './ConvenienceStoreInstruction.scss';

import infoIcon from './assets/ic-info.svg';

class ConvenienceStoreInstruction extends Component {
  static propTypes = {
    t: func.isRequired,
  };

  state = {};

  render() {
    const { t } = this.props;

    const paymentList = t('purchase.newebPaymentList', {
      returnObjects: true,
      defaultValue: [],
    });

    return (
      <div>
        <div className={styles.alert}>
          <img className={styles.icon} src={infoIcon} width={16} height={16} />
          <div className={styles.text}>
            {t('paymentReceipt:paymentReceipt.qrCodeHelpText')}
          </div>
        </div>
        <h5 className={styles.headline}>{t('purchase.newebPaymentTitle')}</h5>
        <ul className={styles.list}>
          {paymentList.map((payment, paymentIndex) => (
            <li className={styles.item} key={paymentIndex}>
              <div className={styles.inner}>
                <span>{payment.title}:</span>
                <a
                  href={payment.link}
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {payment.link}
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default translate(['purchase', 'paymentReceipt'])(
  ConvenienceStoreInstruction
);



// WEBPACK FOOTER //
// ./app/components/ConvenienceStoreInstruction/ConvenienceStoreInstruction.jsx